import { LoaderService } from '@/app/common/services/loader/loader.service';
import { AsyncPipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzSpinModule } from 'ng-zorro-antd/spin';

import { AvatarComponent } from '@/app/common/components/avatar/avatar.component';
import { CompanyService } from '@/app/modules/company/core/service';
import { Company } from '@/app/modules/company/core/type';

@Component({
  templateUrl: './companies.component.html',
  styleUrls: ['./companies.component.scss'],
  standalone: true,
  imports: [
    AsyncPipe,
    FormsModule,
    AvatarComponent,
    NzEmptyModule,
    NzIconModule,
    NzInputModule,
    NzSpinModule,
  ],
})
export class CompaniesCompaniesComponent implements OnInit {
  companies: Company[] = [];
  filteredCompanies: Company[] = [];
  searchTerm = '';

  companiesLoader = new BehaviorSubject<boolean>(false);

  constructor(
    private companyService: CompanyService,
    private notificationService: NzNotificationService,
    private loaderService: LoaderService,
    private route: Router,
  ) {}

  ngOnInit(): void {
    this.handleSearchCompanies();
  }

  handleOpenList(id?: number): void {
    if (id == null) {
      return;
    }
    this.route.navigate([`company/${id}/checklist-headers`]);
  }

  onSearchChange(): void {
    this.applyFilter();
  }

  companyInitials(name: string): string {
    const parts = (name || '')
      .trim()
      .split(/\s+/)
      .filter(Boolean);

    if (!parts.length) {
      return 'EM';
    }

    if (parts.length === 1) {
      return parts[0].slice(0, 2).toUpperCase();
    }

    return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  }

  handleSearchCompanies(pageIndex: number = 1, pageSize: number = 100): void {
    this.loaderService
      .executeWithLoader(
        this.companyService.findAll({
          pageIndex,
          pageSize,
        }),
        this.companiesLoader,
      )
      .subscribe({
        next: ({ items }) => {
          this.companies = items ?? [];
          this.applyFilter();
        },
        error: (error: HttpErrorResponse) => {
          this.notificationService.error(
            `${error.status}`,
            error.error?.message || 'Erro ao carregar empresas.',
          );
        },
      });
  }

  private applyFilter(): void {
    const term = this.searchTerm.trim().toLowerCase();
    if (!term) {
      this.filteredCompanies = [...this.companies];
      return;
    }

    this.filteredCompanies = this.companies.filter((company) =>
      company.name?.toLowerCase().includes(term),
    );
  }
}
